// utils/authFetch.js — fetch con token JWT y manejo de sesión expirada.
// TODAS las llamadas al backend deben pasar por aquí (el backend ya
// rechaza cualquier petición sin token, salvo el login).
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(url, { ...options, headers });

  // Token vencido o inválido → limpiar sesión y mandar al login.
  // (En /login no se redirige: el 401 ahí significa contraseña incorrecta.)
  if (res.status === 401 && !window.location.pathname.startsWith("/login")) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  }

  return res;
}
